let isFacebookSdkInitStarted = false;

export const initFacebookSdk = () => {
    if (typeof window === "undefined") return;
    if (window.FB) return;
    if (isFacebookSdkInitStarted) return;

    isFacebookSdkInitStarted = true;

    window.fbAsyncInit = function () {
        if (!window.FB) return;
        window.FB.init({
            appId: process.env.REACT_APP_WHATSAPP_APP_ID,
            autoLogAppEvents: true,
            xfbml: true,
            version: process.env.REACT_APP_META_API_VERSION || "v20.0"
        });
    };

    const existingSdk = document.getElementById("facebook-jssdk");
    if (existingSdk) return;

    const js = document.createElement("script");
    js.id = "facebook-jssdk";
    js.async = true;
    js.defer = true;
    js.crossOrigin = "anonymous";
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    document.body.appendChild(js);
};

